<template>
  <div class="main">
    <div id="isPC">
      <div class="banner">
        <van-image
          fit="cover"
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/1.png?x-oss-process=image/resize,w_1920"
          class="background"
        />
        <div class="content">
          <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/2.png'" class="logo" alt="格如灵">
          <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/3.png'" class="title" alt="">
          <div class="consult" @click="showCollect=true;isMap=true">点我咨询</div>
        </div>
      </div>
      <div class="plan">
        <div class="list">
          <span>初中虚拟仿真实验训练</span>
          <span>考评系统</span>
          <div class="detail" @click="showCollect=true;isMap=false">详情</div>
        </div>
        <div class="list">
          <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/4.png'" alt="hot">
          <span>K12 5G+XR未来课堂</span>
          <span>白皮书</span>
          <div class="detail" @click="showCollect=true;isMap=false">详情</div>
        </div>
        <div class="list">
          <span>中小学虚拟仿真课堂</span>
          <span>教研方案</span>
          <div class="detail" @click="showCollect=true;isMap=false">详情</div>
        </div>
      </div>
      <div class="education">
        <img class="title" v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/5.png'" alt="">
        <div class="list">
          <div class="detail">
            <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/6.png'" class="num" alt="">
            <div class="line"></div>
            <div class="headline">教育局/电教馆/各类院校</div>
            <div class="desc">可展现省、市、区、校不同层级的实验教学及考评数据，有效管理教学成果，为区域教学方案的决策提供真实完整的数据依据。</div>
          </div>
          <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/8.png'" alt="">
        </div>
        <div class="list second">
          <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/9.png'" alt="">
          <div class="detail">
            <div class="num">
              <div class="line"></div>
              <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/7.png'" alt="">
            </div>
            <div class="headline">教育局/电教馆/各类院校</div>
            <div class="desc">可展现省、市、区、校不同层级的实验教学及考评数据，有效管理教学成果，为区域教学方案的决策提供真实完整的数据依据。</div>
          </div>
        </div>
      </div>
      <div class="system">
        <div class="content">
          <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/11.png'" class="title" alt="">
          <div class="detail">
            <div class="tab">
              <div class="list" v-for="(item, index) of systemList" :key="item.headline">
                <div class="headline" :class="tabIndex == index ? 'active' : ''" @click="changeTab(index)">{{ item.headline }}</div>
                <div class="desc">{{ item.desc }}</div>
              </div>
            </div>
            <img v-lazy="systemList[tabIndex].img" @click="go(systemList[tabIndex].url)" alt="">
          </div>
        </div>
      </div>
      <div class="voice">
        <div class="content">
          <div class="title">
            <div class="people">
              <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/15.png'" class="line" alt="">
              <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/16.png'" alt="">
            </div>
            <div class="desc">
              <span>格如灵已部署</span>
              <span class="emphasis">1000+</span>
              <span>院校，取得大量好评</span>
            </div>
          </div>
          <div class="selected">
            <div class="detail">
              <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/17.png'" alt="">
              <img v-lazy="voiceList[voiceIndex].headline" class="headline" alt="">
              <div class="desc">{{ voiceList[voiceIndex].desc }}</div>
            </div>
            <img v-lazy="voiceList[voiceIndex].img" alt="">
            <div class="previous">
              <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/19.png'" class="click" @click="previous" alt="">
              <div class="mask"></div>
              <img v-lazy="preImg" class="contentImg" alt="">
            </div>
            <div class="next">
              <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/20.png'" class="click" @click="next" alt="">
              <div class="mask"></div>
              <img v-lazy="nextImg" class="contentImg" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="industry">
        <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/25.png'" class="title" alt="">
        <div class="content" @click="go('/eg')">
          <div class="list">
            <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/29.png'" alt="">
            <div class="headline">深圳大学</div>
          </div>
          <div class="list">
            <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/30.png'" alt="">
            <div class="headline">首都师范大学实验学校</div>
          </div>
          <div class="list">
            <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/28.png'" alt="">
            <div class="headline">北京清华附中</div>
          </div>
          <div class="list">
            <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/27.png'" alt="">
            <div class="headline">中国(海南)南海博物馆</div>
          </div>
          <div class="list">
            <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/26.png'" alt="">
            <div class="headline">安徽气象台VR培训</div>
          </div>
          <div class="list">
            <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/31.png'" alt="">
            <div class="headline">油气储运</div>
          </div>
        </div>
      </div>
      <div class="start" @click="showCollect=true;isMap=true">
        <span>即刻开启教育数字化</span>
        <img v-lazy="'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/24.png'" alt="">
      </div>
      <div class="collect" v-if="showCollect" @click.self="showCollect=false">
        <div class="content">
          <div class="detail" v-if="isMap">
            <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/37.png" class="logo" alt="">
            <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/38.png" class="map" alt="">
            <div class="desc">
              <span>格如灵科技以“连接未来的教育”为使命，坚持以客户为中心，</span>
              <span>已经实现了产品和服务在全球10个国家和地区落地，在国内服务了1000+ K12学校，</span>
              <span>100+ 高职高校，同时提供了1000+的XR教学内容，上万3D教学数字资产。</span>
            </div>
          </div>
          <div class="detail noMap" v-else>
            <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/37.png" class="logo" alt="">
            <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/39.png" class="list" alt="">
          </div>
          <div class="fillIn" v-loading="loading">
            <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/35.png" class="title" alt="">
            <div class="list">
              <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/36.png" class="must" alt="">
              <el-input class="inputElement" maxlength="5" v-model="name" placeholder="请输入姓名"></el-input>
            </div>
            <div class="list">
              <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/36.png" class="must" alt="">
              <el-input class="inputElement" maxlength="11" v-model="phone" placeholder="请输入手机号"></el-input>
            </div>
            <div class="list">
              <el-input class="inputElement" maxlength="20" v-model="company" placeholder="请输入公司名称"></el-input>
            </div>
            <div class="submit" @click="submit">提交</div>
          </div>
        </div>
      </div>
    </div>
    <div id="isMobile">
      <div class="banner">
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/2.png" class="logo" alt="格如灵">
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/3.png" class="title" alt="">
      </div>
      <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/40.png" class="line" alt="">
      <div class="education">
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/42.png" class="title" alt="">
        <div class="list">
          <div class="headline">
            <span class="num">01、</span>
            <span>教育局/电教馆/各类院校</span>
          </div>
          <div class="detail">
            <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/8.png" alt="">
            <div class="desc">可展现省、市、区、校不同层级的实验教学及考评数据，有效管理教学成果，为区域教学方案的决策提供真实完整的数据依据。</div>
          </div>
        </div>
        <div class="list">
          <div class="headline">
            <span class="num">02、</span>
            <span>教师/学生/教育人才</span>
          </div>
          <div class="detail">
            <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/9.png" alt="">
            <div class="desc">丰富的教学资源、提高实验教学效果、保障实验教学安全，培养数字化思维的实战教学人才。</div>
          </div>
        </div>
      </div>
      <div class="teach">
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/44.png" class="title" alt="">
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/45.png" class="content" alt="">
      </div>
      <div class="voice">
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/46.png" class="title" alt="">
        <div class="content">
          <div class="headline">
            <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/47.png" alt="">
            <img v-lazy="voiceList[voiceIndex].headlineMobile" alt="">
          </div>
          <div class="desc">{{ voiceList[voiceIndex].desc }}</div>
        </div>
        <div class="operation">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/50.png" @click="previous" alt="">
          <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/49.png" @click="next" alt="">
        </div>
      </div>
      <a href="tel:400-888-1126" class="footer">免费申请解决方案</a>
    </div>
  </div>
</template>
<script>
import { addEdu } from "@/services/api";

export default {
  data() {
    return {
      systemList: [{
        headline: '5G+XR未来课堂',
        desc: '与实际教学知识点紧密结合，将多种形式灵活应用于课堂教学。',
        img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/12.png?x-oss-process=image/resize,w_1200',
        url: '/product'
      },
      {
        headline: '初中虚拟实验训练考评系统',
        desc: '通过虚拟现实交互提供真实体验的虚拟仿真实验室系统，为学校和教师赋能，带来极致的教学体验。',
        img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/13.png',
        url: '/wisdom'
      },
      {
        headline: '中小学虚拟仿真课堂系统',
        desc: '真切感受贴近生活的情境，学校可打造创新性技术校本课程。',
        img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/14.png',
        url: '/productDetail?id=5'
      }],
      tabIndex: 0,
      voiceList: [
        {
          headline: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/18.png',
          headlineMobile: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/18.png',
          desc: '“使用了格如灵“智慧宫”虚拟仿真实验系统，帮助教师紧扣教学大纲开展安全实验教学，提升实验感知和知识结构延伸，给学生带来真实、交互的教学体验。',
          img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/21.png?x-oss-process=image/resize,w_800'
        },
        {
          headline: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/33.png',
          headlineMobile: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/53.png',
          desc: '“格如灵提供的虚拟现实教学解决方案将教学过程中不易理解、比较抽象教学重点难点以VR建模形式展示在教学内容中，让学生身临其境，调动学生学习兴趣理解和记忆，给课堂教学带来新变化新理念。”',
          img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/22.jpg'
        },
        {
          headline: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/32.png',
          headlineMobile: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/54.png',
          desc: '“虚拟内容与课堂知识实验模型紧密结合，同时与虚拟环境和真实世界发生交互，提高学习效率，同时促使学生对知识的理解更加深入更加全面，取得示范性的教学成果。”',
          img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/23.jpg?x-oss-process=image/resize,w_800'
        }
      ],
      voiceIndex: 2,
      name: '',
      phone: '',
      company: '',
      showCollect: false,
      isMap: false,
      loading: false
    };
  },
  computed: {
    preImg() {
      if (this.voiceIndex === 0) {
        return this.voiceList[this.voiceList.length - 1].img
      } else {
        return this.voiceList[this.voiceIndex - 1].img
      }
    },
    nextImg() {
      if (this.voiceIndex === this.voiceList.length - 1) {
        return this.voiceList[0].img
      } else {
        return this.voiceList[this.voiceIndex + 1].img
      }
    }
  },
  created() { },
  mounted() {
    setInterval(() => {
      if (this.tabIndex === 2) {
        this.tabIndex = 0
      } else {
        this.tabIndex++
      }
    }, 3000)
  },
  methods: {
    changeTab(index) {
      this.tabIndex = index
    },
    previous() {
      console.log(this.voiceIndex)
      if (this.voiceIndex === 0) {
        this.voiceIndex = this.voiceList.length - 1
      } else {
        this.voiceIndex--
      }
    },
    next() {
      if (this.voiceIndex === (this.voiceList.length - 1)) {
        this.voiceIndex = 0
      } else {
        this.voiceIndex++
      }
    },
    submit() {
      if (!this.name || !this.phone) {
        this.$message.warning('请补全姓名和手机号')
        return
      }
      this.loading = true
      const data = {
        uname: this.name, // 用户名称
        name: this.company, // 公司名称
        phone: this.phone // 手机号
      }
      addEdu(data).then(res => {
        this.loading = false
        if (res.s === 200) {
          this.name = ''
          this.company = ''
          this.phone = ''
          this.$message.success('提交成功')
          this.showCollect = false
        } else {
          this.$message.info(res.msg)
        }
      })
    },
    go(url) {
      window.open(url)
    }
  }
};
</script>
<style lang="less" scoped>
#isPC {
  padding-bottom: 200px;
  background: #fff;
  .banner{
    width: 100%;
    height: 848px;
    position: relative;
    padding-top: 1px;
    .background{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }
    .content{
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      position: relative;
      z-index: 2;
      .logo{
        width: 116px;
        margin-top: 47px;
        display: block;
      }
      .title{
        width: 874px;
        margin: 0 auto;
        margin-top: 158px;
        display: block;
      }
      .consult{
        width: 305px;
        height: 86px;
        background: #FFFFFF;
        border-radius: 8px;
        margin: 0 auto;
        margin-top: 43px;
        font-size: 30px;
        font-weight: 600;
        color: #EB6925;
        line-height: 86px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .plan{
    margin: 0 auto;
    margin-top: -94px;
    width: 1200px;
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 3;
    .list{
      width: 350px;
      height: 188px;
      background: #FFFFFF;
      box-shadow: 0px 2px 22px -6px rgba(0, 0, 0, 0.39);
      border-radius: 8px;
      padding-top: 43px;
      box-sizing: border-box;
      text-align: center;
      position: relative;
      img{
        position: absolute;
        left: 16px;
        top: 31px;
        width: 29px;
      }
      span{
        font-size: 24px;
        font-weight: 500;
        color: #000000;
        line-height: 1;
        letter-spacing: 1px;
        padding-bottom: 10px;
        display: block;
      }
      .detail{
        width: 84px;
        height: 35px;
        background: linear-gradient(229deg, #F4A31E 0%, #EB6925 100%);
        border-radius: 8px;
        margin: 0 auto;
        margin-top: 16px;
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 35px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .education{
    width: 1200px;
    height: auto;
    margin: 0 auto;
    margin-top: 90px;
    .title{
      width: 765px;
      display: block;
      margin: 0 auto;
      margin-bottom: 121px;
    }
    .list{
      display: flex;
      margin-top: 78px;
      > img{
        width: 610px;
        height: 406px;
      }
      .detail{
        flex: 1;
        .num{
          width: 62px;
          margin-top: 9px;
          margin-left: 8px;
        }
        .line{
          width: 4px;
          height: 30px;
          background: #444A62;
          border-radius: 6px;
          opacity: 0.49;
          margin-top: 11px;
          margin-left: 12px;
        }
        .headline{
          font-size: 36px;
          font-weight: 600;
          color: #444A62;
          line-height: 50px;
          letter-spacing: 3px;
          margin-top: 14px;
        }
        .desc{
          width: 515px;
          font-size: 26px;
          font-weight: 400;
          color: #000000;
          line-height: 50px;
          margin-top: 42px;
          text-align: justify;
        }
      }
    }
    .second{
      .detail{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .num{
          width: auto;
          display: flex;
          align-items: center;
          > img{
            width: 62px;
          }
          .line{
            width: 29px;
            height: 4px;
            margin-right: 15px;
          }
        }
      }
    }
  }
  .system{
    width: 100%;
    height: 1080px;
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/10.png);
    background-size: auto 100%;
    background-position: center;
    margin-top: 139px;
    overflow: hidden;
    .content{
      width:  1200px;
      margin: 0 auto;
      overflow: hidden;
      .title{
        width: 871px;
        display: block;
        margin: 0 auto;
        margin-top: 84px;
      }
      .detail{
        .tab{
          display: flex;
          justify-content: space-between;
          margin-top: 104px;
          .list{
            width: 320px;
            height: 256px;
            .headline{
              width: 320px;
              height: 72px;
              background: rgba(171, 171, 171, .9);
              border-radius: 8px;
              font-size: 22px;
              font-weight: 600;
              color: #FFFFFF;
              line-height: 72px;
              letter-spacing: 2px;
              text-align: center;
              cursor: pointer;
            }
            .active{
              background: linear-gradient(224deg, rgba(244, 161, 31, .9) 0%, rgba(235, 105, 37, .9) 100%);
            }
            .desc{
              font-size: 20px;
              font-weight: 400;
              color: #000000;
              line-height: 34px;
              margin-top: 23px;
              text-align: center;
            }
          }
        }
        > img{
          width: 1200px;
          cursor: pointer;
        }
      }
    }
  }
  .voice{
    margin-top: 71px;
    overflow: hidden;
    .content{
      width: 1200px;
      margin: 0 auto;
      .title{
        position: relative;
        height: 159px;
        width: 100%;
        text-align: right;
        padding-top: 1px;
        .desc{
          margin-top: 123px;
          span{
            font-size: 24px;
            font-weight: 600;
            color: #787C8D;
            line-height: 50px;
          }
          .emphasis{
            color: rgba(235, 105, 37, 1);
            font-size: 30px;
          }
        }
        .people{
          position: absolute;
          top: 0;
          right: 0;
          height: 159px;
          width: 100%;
          > img:nth-child(1){
            width: 1200px;
            height: 6px;
            position: absolute;
            right: 288px;
            top: 77px;
          }
          > img:nth-child(2){
            width: 234px;
            height: 159px;
            position: absolute;
            right: 0;
            top: 0;
          }
        }
      }
      .selected{
        width: 1115px;
        height: 570px;
        margin: 0 auto;
        position: relative;
        .detail{
          width: 756px;
          height: 100%;
          background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/34.png);
          background-size: 100% 100%;
          position: relative;
          z-index: 2;
          > img:nth-child(1){
            width: 86px;
            display: block;
            margin-top: 39px;
            margin-left: 24px;
          }
          .headline{
            width: 223px;
            display: block;
            margin-top: 12px;
            margin-left: 30px;
          }
          .desc{
            width: 451px;
            font-size: 24px;
            font-weight: 600;
            color: #444A62;
            line-height: 50px;
            margin-top: 43px;
            margin-left: 30px;
          }
        }
        > img{
          position: absolute;
          right: 0;
          top: 0;
          width: 816px;
          height: 100%;
        }
        .previous, .next{
          position: absolute;
          top: 0;
          right: 1206px;
          width: 816px;
          height: 570px;
          .click{
            position: absolute;
            top: 260px;
            right: -26px;
            width: 51px;
            z-index: 2;
            cursor: pointer;
          }
          .mask{
            width: 100%;
            height: 100%;
            background: #FFFFFF;
            opacity: 0.75;
            position: absolute;
            left: 0;
            right: 0;
          }
          .contentImg{
            width: 100%;
            height: 100%;
          }
        }
        .next{
          left: 1206px;
          right: auto;
          .click{
            left: -26px;
            right: auto;
          }
        }
      }
    }
  }
  .industry{
    .title{
      width: 476px;
      height: 113px;
      margin: 0 auto;
      margin-top: 122px;
      display: block;
    }
    .content{
      width: 1200px;
      margin: 0 auto;
      margin-top: 44px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      cursor: pointer;
      .list{
        width: 390px;
        height: 311px;
        position: relative;
        margin-bottom: 20px;
        > img{
          width: 100%;
          height: 100%;
        }
        .headline{
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 65px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0,0,0,.79);
          border-radius: 0px 0px 6px 6px;
          font-size: 24px;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }
  }
  .start{
    width: 550px;
    height: 120px;
    background: #EB6925;
    border-radius: 8px;
    margin: 0 auto;
    margin-top: 84px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    span{
      font-size: 30px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 1;
      margin-right: 6px;
    }
    > img{
      width: 26px;
    }
  }
  .collect{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 4;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    .content{
      width: 1197px;
      height: 680px;
      background: #FFFFFF;
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      display: flex;
      overflow: hidden;
      .detail{
        width: 601px;
        background: #F4F7FA;
        .logo{
          width: 88px;
          display: block;
          margin-top: 28px;
          margin-left: 28px;
        }
        .map{
          width: 551px;
          margin-top: 123px;
          margin-left: 27px;
          display: block;
        }
        .desc{
          width: 100%;
          text-align: center;
          margin-top: 72px;
          span{
            font-size: 14px;
            font-weight: 400;
            color: #000000;
            line-height: 30px;
            display: block;
          }
        }
      }
      .noMap{
        > img:nth-child(2){
          width: 530px;
          display: block;
          margin-top: 28px;
          margin-left: 30px;
        }
      }
      .fillIn{
        width: 596px;
        padding: 0 74px;
        box-sizing: border-box;
        .title{
          width: 150px;
          display: block;
          margin: 0 auto;
          margin-top: 76px;
          margin-bottom: 59px;
        }
        .list{
          width: 100%;
          height: 68px;
          margin-top: 30px;
          position: relative;
          .must{
            position: absolute;
            top: 50%;
            margin-top: -5px;
            width: 10px;
            margin-left: 25px;
            z-index: 2;
          }
          .inputElement{
            width: 100%;
            height: 100%;
            // padding-left: 100px;
            /deep/ .el-input__inner{
              background: #F3F5F7;
              border-radius: 34px;
              width: 100%;
              height: 100%;
              padding: 0 48px;
              font-size: 20px;
              font-weight: 400;
              color: #0D2340;
              border: none;
            }
          }
        }
        .submit{
          width: 449px;
          height: 73px;
          background: #EB6925;
          border-radius: 37px;
          margin: 0 auto;
          margin-top: 68px;
          font-size: 22px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 73px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }
}
#isMobile{
  background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/41.png);
  background-size: 100%;
  background-repeat: no-repeat;
  padding-bottom: 170px;
  .banner{
    margin-top: -100px;
    padding-top: 1px;
    .logo{
      width: 84px;
      display: block;
      margin-top: 26px;
      margin-left: 52px;
    }
    .title{
      width: 656px;
      display: block;
      margin: 0 auto;
      margin-top: 100px;
    }
  }
  .line{
    width: 742px;
    display: block;
    margin: 0 auto;
    margin-top: 146px;
  }
  .education{
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/43.png);
    background-size: 100% 100%;
    width: 702px;
    margin: 0 auto;
    margin-top: -30px;
    position: relative;
    z-index: 2;
    padding-bottom: 54px;
    padding-top: 1px;
    .title{
      width: 202px;
      margin: 0 auto;
      margin-top: 38px;
      display: block;
    }
    .list{
      padding: 0 54px;
      box-sizing: border-box;
      margin-top: 38px;
      .headline{
        margin-top: 38px;
        display: flex;
        align-items: center;
        span{
          font-size: 28px;
          font-weight: 500;
          color: #534D7A;
          line-height: 40px;
        }
        .num{
          font-size: 24px;
        }
      }
      .detail{
        width: 100%;
        height: 290px;
        position: relative;
        margin-top: 20px;
        border-radius: 20px;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
        }
        .desc{
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          background: linear-gradient(224deg, rgba(244, 161, 31, .89) 0%, rgba(235, 105, 37, .89) 100%);
          padding: 16px 22px;
          box-sizing: border-box;
          font-size: 24px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 32px;
        }
      }
    }
  }
  .teach{
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/51.png);
    background-size: 100% 100%;
    width: 702px;
    margin: 0 auto;
    margin-top: 28px;
    padding-top: 1px;
    padding-bottom: 56px;
    .title{
      width: 192px;
      display: block;
      margin: 0 auto;
      margin-top: 40px;
    }
    .content{
      width: 670px;
      margin-left: 16px;
      margin-top: 26px;
      display: block;
    }
  }
  .voice{
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/marketing/education/52.png);
    background-size: 100% 100%;
    width: 702px;
    height: 556px;
    margin: 0 auto;
    margin-top: 28px;
    padding: 1px 36px 56px 36px;
    box-sizing: border-box;
    .title{
      width: 192px;
      display: block;
      margin: 0 auto;
      margin-top: 40px;
    }
    .content{
      margin-top: 72px;
      .headline{
        display: flex;
        align-items: center;
        > img:nth-child(1){
          width: 60px;
          margin-right: 16px;
        }
        > img:nth-child(2){
          height: 44px;
        }
      }
      .desc{
        font-size: 24px;
        font-weight: 400;
        color: #384858;
        line-height: 52px;
        min-height: 206px;
        margin-top: 24px;
      }
    }
    .operation{
      display: flex;
      width: 100%;
      padding: 0 118px;
      box-sizing: border-box;
      justify-content: space-between;
      margin-top: 16px;
      img{
        width: 140px;
        height: 54px;
      }
    }
  }
  .footer{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 104px;
    background: #EB6925;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    z-index: 5;
  }
}
</style>
